
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import { newList } from "@/apis/home";
import { formatUpyunUrl } from "@/utils";
import { dateToStr } from "@/utils/index";
// import {openJesongChat} from "easy"
import Breadcrumb from "@/components/Breadcrumb/index.vue";
@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb
  }
})
export default class InternalTraining extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  dateToStr = dateToStr;
  List = [
    { title: "光华商学院", url: "" },
    { title: "企业内训（学习项目）", url: "" }
  ];

  dataList = [];

  pic1 = "/img/ad36bf5f171b7ca1498a11bd3adf8d36.png";
  pic2 = "/img/51efb04a16978cf2eb6f6e0cfd6faf1e.png";
  pic3 = "/img/90b7491c9eaa64e542e82fe55a3c37f6.png";
  pic4 = "/img/cbfce00ceb6dd8ae9673f798b94fbb0c.png";

  created() {
    this.newList();
  }

  async newList() {
    const { data } = await newList({
      action: "list",
      classid: 39,
      page: 1,
      type: 1,
      per_page: 4
    });
    this.dataList = data || [];
  }

  toDetail(item: any) {
    this.$router.push(`case-detail?id=${item.case_id}&page=1`);
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华商学院，公开课,企业内训，公开课，企业培训,公开课培训网,时代光华公开课"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训，线下课程，管理培训，公开课培训,新员工培训，股权咨询，体系课程，管理课程，销售课程，HR课程，HRBP，运营课程，团队，领导力，AI，人工智能，办公效率提升，训战营，主播，全域营销，必修课，选修课，集训，实战，实操，实用，实地，实在，学，练，考，评，赛，实战运营，项目管理，战略，绩效，绩效体系，人才管理，AI+组织技能，组织发展，管理创新，财务，，学院，总裁，管理，人力，运营，职场，财务，生成，制造，宏观经济，战略/变革，组织发展，招聘面试，高层管理，基层管理，中层管理，管理创新，市场营销，薪酬绩效，培训体系，项目研发，财务管理，劳动法，数智化制造，仓储物流，生产计划，税务筹划，预算管控，职业技能，PPT，EXCEL，WORD，办公Office系列,TTT，市场营销，线上流量，私域流量，业务团队，平台流量，采购供应链，质量管理，精益生产，降本增效，应收账款，现场管理，班组长"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
